import {createContext,useContext} from 'react';
import {createGlobalStyle} from "styled-components";
import useLocalStorage from 'use-local-storage';
import {LightenDarkenColor} from 'lighten-darken-color';
import HexToRgba from "../helpers/colorHelper";

interface ThemeColorContextType {
    primary: string, 
    setPrimary: (color: string) => void, 
    secondary: string, 
    setSecondary: (colo: string) => void
}

const ThemeColorContext = createContext<ThemeColorContextType>({
    primary: '#538abc', 
    setPrimary: () => {}, 
    secondary: '#41539e', 
    setSecondary: () => {}
});

export const usePrimaryColor = () => {
    const context = useContext(ThemeColorContext);
    if (!context) {
        return '#538abc';
    }
    return context.primary;
}

const ThemeColorProvider = ({children}: any) => {
    const [primary, setPrimary] = useLocalStorage("primary_color", "#538abc");
    const [secondary, setSecondary] = useLocalStorage("secondary_color", "#41539e");

    const PrimaryRgba = HexToRgba(`${primary}`);
    const PrimaryLite = HexToRgba(`${primary}`, 0.08);
    const PrimaryTrans = HexToRgba(`${primary}`, 0.8);
    const SecondaryRgba = HexToRgba(`${secondary}`);
    const PrimaryDark = LightenDarkenColor(primary, -20);

    const GlobalStyles = createGlobalStyle`
        :root {
            --primary       : ${PrimaryRgba};
            --pLite         : ${PrimaryLite};
            --pDark         : ${PrimaryDark};
            --pTransparent  : ${PrimaryTrans};
            --secondary     : ${SecondaryRgba};
        }
    `;

    return (
        <ThemeColorContext.Provider value={{primary, setPrimary, secondary, setSecondary}}>
            <GlobalStyles/>
            {children}
        </ThemeColorContext.Provider>
    );
}

export {ThemeColorProvider, ThemeColorContext};